export const DIGITAL_BUSINESS_CARDS = {
  amer: {
    name: "Amer Al Fayadh",
    title: "CEO & Founder",
    company: "COMMUNICATION ESSENTIALS LLC",
    phone: "717.992.2885",
    whatsapp: "https://wa.me/17179922885",
    email: "amer@communicationessentialsllc.com",
    linkedin: "https://www.linkedin.com/in/amer-al-fayadh-177012134/",
    address: "PO Box 115 Bausman, PA 17504-0115",
  },
  operations: {
    name: "Operations Team",
    title: "Operations Manager",
    company: "COMMUNICATION ESSENTIALS LLC",
    phone: "717.992.2885",
    whatsapp: "https://wa.me/17179922885",
    email: "operations@communicationessentialsllc.com",
    linkedin: "",
    address: "PO Box 115 Bausman, PA 17504-0115",
  },
};
